import { delById } from '@/api/commManage'

const commonData = {
  data () {
    return {
      // 商品名称
      tradeName: '',
      /** 商品分组 */
      commGroup: undefined,
      // 发布时间
      date: '',
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      // 发布方
      publisher: undefined,
      // 状态
      status: undefined,
      // 回收点名称
      postStationName: '',
      /**
       * 省市区
       *
       */
      options: [],
      areaContain: [],
      /**
       * 列表
       *
       */
      // 列表数据
      tableData: [],
      // 分页数据
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      // 列表loading
      loading: false,
      selectOption: [],
      /**
       * 删除model
       */
      delLoading: false,
      delVisible: false,
      delId: ''

    }
  },
  mounted () {
    this.getArea('', 2, null, true)
  },
  methods: {
    /**
     * 省市区
     *
     */
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    onAreaChange (value, obj) {
      this.estateList = []
      this.estate = undefined
      if (value.length < 4) {
        this.getEstate(value)
      } else if (value.length === 4) {
        this.getEstate(null, value[3])
      }
    },
    // 删除
    del (item) {
      this.delId = item.id
      this.delVisible = true
    },
    async delOk () {
      this.delLoading = true
      try {
        const res = await delById({ id: this.delId })
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.delVisible = false
          this.getGoodsList()
          return
        }
      } finally {
        this.delLoading = false
      }
    },
    delCancel () {
      this.delVisible = false
    }
  }
}

export {
  commonData
}
